import { useMutation } from "@tanstack/react-query";
import {
  getApiUrl,
  postInvoicesSettlementInvoicesInvoiceNumberRegeneratePath,
} from "Infrastructure/Api/Api";
import { JWT_KEY } from "Utils/AuthUtils";
import { getLocalStorageItem } from "Utils/Storage/LocalStorage/SecureLocalStorage";
import FileSaver from "file-saver";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Settlements.SettlementList;

type Params = {
  invoiceNumber: number;
};

const regenerateSettlementInvoice = async ({ invoiceNumber }: Params) => {
  const route = `${getApiUrl()}${postInvoicesSettlementInvoicesInvoiceNumberRegeneratePath(invoiceNumber)}`;
  const response = await fetch(route, {
    method: "POST",
    mode: "cors",
    headers: { Authorization: getLocalStorageItem(JWT_KEY) ?? "" },
  });

  return response;
};

export const useRegenerateSettlementInvoiceMutation = () => {
  const { t } = useResource();

  return useMutation({
    mutationFn: async (params: Params) => {
      const response = await regenerateSettlementInvoice(params);
      if (!response.ok) {
        throw new Error(t(COMPONENT_RESOURCES.RegenerateInvoiceError));
      }
      const blob = await response.blob();
      const fileName = `${t(COMPONENT_RESOURCES.InvoiceFilePrefix)}${params.invoiceNumber}.pdf`;
      FileSaver.saveAs(blob, fileName);
    },
    onSuccess: () => {
      toast.success(t(COMPONENT_RESOURCES.RegenerateInvoiceSuccess));
    },
    onError: () => {
      toast.error(t(COMPONENT_RESOURCES.RegenerateInvoiceError));
    },
  });
};
